import React, { useState } from 'react';
import { invoiceTemplates } from '../components/invoice/invoiceTemplates';
import InvoiceRenderer from '../components/invoice/InvoiceRenderer';
import '../styles/AddCompanyForm.css'; // Reusing format-grid and modal classes

const getDummyMappedInvoiceData = () => {
    return {
        buyer: {
            name: 'AeroTech Manufacturing Ltd',
            realName: 'AeroTech Manufacturing Ltd',
            address: 'Plot No. 42, GIDC Estate, Phase-III',
            cityState: 'Ahmedabad, Gujarat - 382445',
            placeOfSupply: 'Gujarat',
            stateCode: '24',
            gstin: '24ABCDE1234F1Z0',
            pan: 'ABCDE1234F'
        },
        consignee: {
            name: 'AeroTech Manufacturing Ltd (Warehouse)',
            address: 'Plot No. 42, GIDC Estate, Phase-III',
            cityState: 'Ahmedabad, Gujarat - 382445',
            placeOfSupply: 'Gujarat',
            stateCode: '24',
            gstin: '24ABCDE1234F1Z0',
            pan: 'ABCDE1234F'
        },
        invoiceNo: 'ASE/26-27/0042',
        invoiceDate: new Date().toLocaleDateString('en-GB'),
        eWayBillNo: '171234567890',
        sealNo: 'SEAL88374',
        vehicleNo: 'GJ-01-XX-9999',
        transporter: 'Vikas Roadlines',
        lrNo: 'LR-998822',
        lrDate: '26/03/2026',
        containerNo: 'CON-776655',
        paymentTerms: '30 Days Credit',
        extraChargesName: 'Freight Charges',
        items: [
            {
                srNo: 1,
                product: 'Glazed Vitrified Tile (800x1200 mm)',
                category: 'Ceramic Tiles',
                model: '800x1200 mm',
                hsn: '69072100',
                grade: 'Premium',
                color: 'White',
                qty: 120,
                unit: 'BOX',
                rate: '450.00',
                amount: '54000.00'
            },
            {
                srNo: 2,
                product: 'Super-Bond Epoxy Adhesive (5kg)',
                category: 'Adhesives',
                model: '5 kg Bucket',
                hsn: '35069190',
                grade: 'Standard',
                color: 'N/A',
                qty: 10,
                unit: 'PCS',
                rate: '1250.00',
                amount: '12500.00'
            }
        ],
        totals: {
            qty: 130,
            subTotal: '66500.00',
            discount: '1500.00',
            discountPercent: '2.25',
            discountType: '%',
            insurance: '200.00',
            insurancePercent: '0.3',
            extra: '500.00',
            taxableAmount: '65700.00',
            tax1Rate: 9,
            tax1: '5913.00',
            tax2Rate: 9,
            tax2: '5913.00',
            totalTax: '11826.00',
            words: 'Seventy Seven Thousand Five Hundred Twenty Six Rupees Only',
            grandTotal: '77526.00',
            isLocal: true
        },
        bank: {
            accountName: 'ASENCIA ENTERPRISE LTD',
            name: 'HDFC Bank',
            accountNumber: '50200012345678',
            ifsc: 'HDFC0001234'
        }
    };
};

const FormatList = () => {
    const [previewFormat, setPreviewFormat] = useState(null);

    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <h2 style={{ marginBottom: '20px', color: '#1e293b', fontSize: '24px', fontWeight: 'bold' }}>Available Invoice Formats</h2>
            
            <div className="invoice-format-selector" style={{ marginTop: 0 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
                    {Object.values(invoiceTemplates).map((template) => (
                        <div 
                            key={template.id} 
                            style={{ 
                                width: '100%', 
                                border: '1px solid rgba(0,0,0,.125)', 
                                borderRadius: '0.25rem', 
                                overflow: 'hidden', 
                                backgroundColor: '#fff', 
                                display: 'flex', 
                                flexDirection: 'column' 
                            }}
                        >
                            {/* Live Thumbnail Preview */}
                            <div style={{ 
                                width: '100%', 
                                height: '220px', 
                                overflow: 'hidden',
                                position: 'relative',
                                backgroundColor: '#f1f5f9', 
                                borderBottom: '1px solid rgba(0,0,0,.125)',
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <div style={{
                                    width: '800px',
                                    transform: 'scale(0.35)',
                                    transformOrigin: 'top center',
                                    pointerEvents: 'none',
                                    position: 'absolute',
                                    top: '10px'
                                }}>
                                    <InvoiceRenderer
                                        data={{
                                            Company: {
                                                company_name: 'Asencia Enterprise Ltd',
                                                invoiceFormat: template.id
                                            }
                                        }}
                                        invoiceData={getDummyMappedInvoiceData()}
                                        selectedPaymentType="Debit"
                                        selectedInvoiceType="TAX INVOICE"
                                        selectedCopyType="Original"
                                        getImageUrl={() => null}
                                    />
                                </div>
                            </div>
                            
                            {/* Card Body */}
                            <div style={{ padding: '1.25rem', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <h5 style={{ margin: '0 0 1rem 0', fontSize: '1.25rem', fontWeight: 500, color: '#212529' }}>
                                    {template.name}
                                </h5>
                                
                                <button 
                                    type="button" 
                                    onClick={() => setPreviewFormat(template.id)}
                                    style={{ 
                                        backgroundColor: '#0d6efd', 
                                        color: '#fff', 
                                        border: '1px solid #0d6efd', 
                                        padding: '0.375rem 0.75rem', 
                                        fontSize: '1rem', 
                                        borderRadius: '0.25rem',
                                        cursor: 'pointer',
                                        lineHeight: 1.5,
                                        fontWeight: 400
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = '#0b5ed7';
                                        e.target.style.borderColor = '#0a58ca';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = '#0d6efd';
                                        e.target.style.borderColor = '#0d6efd';
                                    }}
                                >
                                    View sample
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal Sample Preview */}
            {previewFormat && (
                <div className="invoice-preview-modal-overlay" onClick={() => setPreviewFormat(null)}>
                    <div className="invoice-preview-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="invoice-preview-modal-header">
                            <h3>Sample Invoice Preview - {previewFormat.toUpperCase().replace('FORMAT', 'FORMAT ')}</h3>
                            <button className="invoice-preview-modal-close" onClick={() => setPreviewFormat(null)}>&times;</button>
                        </div>
                        <div className="invoice-preview-modal-body">
                            <InvoiceRenderer
                                data={{
                                    Company: {
                                        company_name: 'Asencia Enterprise Ltd',
                                        company_address: '101, Corporate Hub, Morbi, Gujarat',
                                        company_mobile_1: '9409010040',
                                        company_email: 'info@asencia.com',
                                        company_gst_number: '24AAAAA0000A1Z5',
                                        company_pan_card_number: 'AAAAA0000A',
                                        company_state: 'Gujarat',
                                        company_pin_code: '363641',
                                        company_bank_name: 'HDFC Bank',
                                        company_bank_account_name: 'ASENCIA ENTERPRISE LTD',
                                        company_bank_account_number: '50200012345678',
                                        company_bank_ifsc_code: 'HDFC0001234',
                                        invoiceFormat: previewFormat
                                    }
                                }}
                                invoiceData={getDummyMappedInvoiceData()}
                                selectedPaymentType="Debit"
                                selectedInvoiceType="TAX INVOICE"
                                selectedCopyType="Original"
                                getImageUrl={(url) => url}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FormatList;
